import { Instagram, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#070707] border-t border-white/5 px-6 md:px-12 py-14"
        >
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
                <div>
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center justify-center w-8 h-8 border border-[#9D4CDD]/50 bg-[#9D4CDD]/10 font-heading font-black text-[#9D4CDD] text-xs">
                            AC
                        </span>
                        <span className="font-heading font-black uppercase text-white tracking-[0.18em] text-sm">
                            AC Detailing
                        </span>
                    </div>
                    <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
                        Family-run premium auto detailing in Surprise, AZ. Hand-
                        washed, hand-finished — always.
                    </p>
                </div>
                <div>
                    <div className="font-heading text-[10px] uppercase tracking-[0.28em] text-[#9D4CDD] font-bold mb-4">
                        Service Area
                    </div>
                    <div className="flex items-start gap-3 text-sm text-white/70">
                        <MapPin size={14} className="mt-1 text-[#9D4CDD]" />
                        <div>
                            Surprise, AZ<br />
                            Sun City West • El Mirage • Waddell •<br />
                            Peoria • Goodyear • West Valley
                        </div>
                    </div>
                </div>
                <div>
                    <div className="font-heading text-[10px] uppercase tracking-[0.28em] text-[#9D4CDD] font-bold mb-4">
                        Connect
                    </div>
                    <div className="flex items-center gap-3">
                        <a
                            href="https://www.instagram.com/acdetalingaz/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="social-instagram"
                            className="w-10 h-10 flex items-center justify-center border border-white/10 text-white/70 hover:text-[#9D4CDD] hover:border-[#9D4CDD]/50 transition-colors"
                            aria-label="Instagram"
                        >
                            <Instagram size={16} />
                        </a>
                    </div>
                    <div className="mt-6 text-xs text-white/40 font-sans">
                        (702) 376-6498 · aiden.chapa@acdetailingaz.com
                    </div>
                </div>
            </div>
            <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-[11px] text-white/40 font-heading uppercase tracking-[0.2em]">
                <div>© {new Date().getFullYear()} AC Detailing. All rights reserved.</div>
                <div>Surprise, Arizona</div>
            </div>
        </footer>
    );
}
